const renderDrafts = require('./render-drafts');

/*
/* Configure the client to render
/* -------------------------------
/* either via argument: eleventy client=erotik
/* or via EVN variable: SET SWINGERCLUB_CLIENT=erotik
/*
/* Default is erotik
 */

let client = 'erotik';

switch (true) {
  default:
    break;

  case process.argv.includes('client=dvderotik'):
    client = 'dvderotik';
    break;

  case !!process.env.SWINGERCLUB_CLIENT:
    client = process.env.SWINGERCLUB_CLIENT;
    break;
}

/*
/* Configure the API endpoint to use
/* ---------------------------------
/* either via argument: eleventy endpoint=https://api.erotik.com
/* or via EVN variable: SET SWINGERCLUB_ENDPOINT=https://api.erotik.com
/*
/* Default is https://api.erotik-staging.ffrtz.com/vod/
 */

let endpoint = 'https://api.erotik-staging.ffrtz.com/vod/';
const arg = process.argv.find((element) => element.startsWith('endpoint='));

switch (true) {
  default:
    break;

  case !!arg: {
    const parts = arg.split('=');
    if (parts.length === 2) {
      endpoint = parts[1];
    }
    break;
  }

  case !!process.env.SWINGERCLUB_ENDPOINT:
    endpoint = process.env.SWINGERCLUB_ENDPOINT;
    break;
}

/*
/* Configure if only rendering a few pages of each type
/* -------------------------------
/* via argument: eleventy fast
/*
/* Default is false
 */

let fastMode = false;

switch (true) {
  default:
    break;

  case process.argv.includes('fast'):
    fastMode = true;
    break;
}

module.exports = {
  client,
  languages: ['de', 'en', 'nl'],
  renderDrafts,
  endpoint,
  apiRoutes: (() => {
    const pathPrefix = '';
    const catalogPathPrefix = `${pathPrefix}${client !== 'dvderotik' ? '/vod' : '/dvd'}`;
    const contentApiPrefix = `${pathPrefix}/content`;
    const searchApiPrefix = `${catalogPathPrefix}/search`;
    const recommendApiPrefix = `${catalogPathPrefix}/recommend`;

    return {
      me: `${pathPrefix}/me`,
      config: `${pathPrefix}/config`,
      cart: `${pathPrefix}/cart`,
      promotions: `${pathPrefix}/promotions`,
      autocomplete: `${pathPrefix}/autocomplete`,
      banners: `${pathPrefix}/banners`,
      ratings: `${pathPrefix}/ratings`,
      notifyMe: `${pathPrefix}/watch-item`,
      notifications: `${pathPrefix}/notifications`,
      like: `${pathPrefix}/like`,
      trackPlayback: `${pathPrefix}/track-playback`,
      lastSeen: `${pathPrefix}/lastseen`,
      feedInit: `${pathPrefix}/feed/init`,

      addressBook: `${pathPrefix}/account/address-book`,
      paymentMethods: `${pathPrefix}/account/payment-methods`,
      requestConfirmationEmail: `${pathPrefix}/account/request-confirmation-email`,

      checkoutInitialize: `${pathPrefix}/checkout/initialize`,
      checkoutResume: `${pathPrefix}/checkout/resume`,
      checkoutState: `${pathPrefix}/checkout/state`,
      checkoutTransaction: `${pathPrefix}/checkout/transaction`,
      checkoutBillingAddress: `${pathPrefix}/checkout/billing-address`,
      checkoutShippingAddress: `${pathPrefix}/checkout/shipping-address`,
      checkoutPaymentMethod: `${pathPrefix}/checkout/payment-method`,
      checkoutPaymentMethods: `${pathPrefix}/checkout/payment-methods`,
      checkoutShippingMethod: `${pathPrefix}/checkout/carrier`,
      checkoutShippingMethods: `${pathPrefix}/checkout/carriers`,
      checkoutComment: `${pathPrefix}/checkout/comment`,
      checkoutPayment: `${pathPrefix}/checkout/payment`,
      checkoutTransactionStatus: `${pathPrefix}/checkout/transaction-status`,
      checkoutCancelTransaction: `${pathPrefix}/checkout/cancel-transaction`,
      checkoutPaymentSuccess: `${pathPrefix}/checkout/payment-success`,

      download: `${catalogPathPrefix}/download`,
      downloadSources: `${catalogPathPrefix}/download/sources`,
      telemetryVideo: `${catalogPathPrefix}/telemetry`,

      suggestCategories: `${pathPrefix}/suggest/category`,
      suggestPerformers: `${pathPrefix}/suggest/performer`,

      contentMovies: `${contentApiPrefix}/movies`,
      contentScenes: `${contentApiPrefix}/scenes`,
      contentStudios: `${contentApiPrefix}/studios`,
      contentPerformers: `${contentApiPrefix}/performers`,
      contentAmateurs: `${contentApiPrefix}/amateurs`,
      contentClips: `${contentApiPrefix}/clips`,

      streamingSources: `${pathPrefix}/vod/streaming/sources`,

      searchCategories: `${searchApiPrefix}/categories`,
      searchMovies: `${searchApiPrefix}/movies`,
      searchScenes: `${searchApiPrefix}/scenes`,
      searchStudios: `${searchApiPrefix}/studios`,
      searchPerformers: `${searchApiPrefix}/performers`,
      searchAmateurs: `${searchApiPrefix}/amateurs`,
      searchClips: `${searchApiPrefix}/clips`,

      recommendMovies: `${recommendApiPrefix}/movies`,
      recommendScenes: `${recommendApiPrefix}/scenes`,
      recommendPerformers: `${recommendApiPrefix}/performers`,
      recommendStudios: `${recommendApiPrefix}/studios`,
    };
  })(),
  points: (() => {
    switch (client) {
      default:
        return {
          factor: 10,
          daysOnHold: 0,
        };

      case 'dvderotik':
        return undefined;
    }
  })(),
  clientName: (() => {
    switch (client) {
      default:
        return 'EROTIK.com';

      case 'dvderotik':
        return 'DVDEROTIK.com';
    }
  })(),
  environment: endpoint.indexOf('staging') > -1 ? 'dev' : 'prod',
  clientHost: (() => {
    switch (client) {
      default:
        return endpoint.indexOf('staging') > -1 ? 'https://erotik-staging.ffrtz.com' : 'https://erotik.com';

      case 'dvderotik':
        return endpoint.indexOf('staging') > -1 ? 'https://dvderotik-staging.ffrtz.com' : 'https://www.dvderotik.com';
    }
  })(),
  apiBase: (() => {
    switch (client) {
      default:
        return endpoint.indexOf('staging') > -1 ? 'https://api.erotik-staging.ffrtz.com' : 'https://api.erotik.com';

      case 'dvderotik':
        return endpoint.indexOf('staging') > -1 ? 'https://api.dvderotik-staging.ffrtz.com' : 'https://api.dvderotik.com';
    }
  })(),
  cms: (() => {
    const apiBase = 'https://cms.erotik.com/api';
    const apiKey = 'USR-fb9af1fb317b9fa5bd019dbae4ac69c0c6c42dbd';

    return {
      apiBase,
      apiKey,
    };
  })(),
  hasScenes: (() => {
    switch (client) {
      default:
        return true;

      case 'dvderotik':
        return false;
    }
  })(),
  hasAmateurs: (() => {
    switch (client) {
      default:
        return true;

      case 'dvderotik':
        return false;
    }
  })(),
  hasEPoints: (() => {
    switch (client) {
      default:
        return true;

      case 'dvderotik':
        return false;
    }
  })(),
  // eslint-disable-next-line no-confusing-arrow
  maxNumberOfPages: (() => (endpoint.indexOf('staging') > -1 ? 2 : 10))(),
  originTrials: (() => {
    switch (client) {
      default:
        return {};

      case 'dvderotik':
        return {};
    }
  })(),
  salesModel: 'payPerItem',
  productDeliveryType: (() => {
    switch (client) {
      default:
        return 'vod';

      case 'dvderotik':
        return 'disc';
    }
  })(),
  fastMode,
};



// WEBPACK FOOTER //
// ./src/_utilities/environment.js